/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  ResourceExecutionErrorCodeCount,
  useEventActionStatusChangedSubscription,
} from "~/generated/graphql";
import {
  getEventEntityStatus,
  getEventEntityStatusWithAttention,
} from "../helpers";
import { EntityType } from "../types";
import { TooltipIconStatus } from "./TooltipIconStatus";

type Props = {
  eventActionId: string;
  eventActionStatus?: string;
  errorCodeCounts: ResourceExecutionErrorCodeCount[];
  isEventFinished: boolean;
  onEventActionStatusChanged: () => void;
};

export function EventActionStatus({
  eventActionId,
  eventActionStatus,
  errorCodeCounts,
  isEventFinished,
  onEventActionStatusChanged,
}: Props) {
  const { data } = useEventActionStatusChangedSubscription({
    variables: {
      input: {
        id: eventActionId,
      },
    },
    onData: onEventActionStatusChanged,
  });
  const liveStatus = data?.eventActionStatusChanged ?? eventActionStatus;
  const statusDetails = isEventFinished
    ? getEventEntityStatusWithAttention({
        status: liveStatus,
        errorCodeCounts,
      })
    : getEventEntityStatus(liveStatus);

  return (
    <TooltipIconStatus
      status={liveStatus}
      statusDetails={statusDetails}
      type={EntityType.ACTION}
    />
  );
}
